import { AuthShell, CardThemeToggle } from "./AuthShell";
import { VerifyReceiptForm } from "../../components/VerifyReceipt/VerifyReceiptForm";

/**
 * Public receipt-verification page — no account needed, so a bank, a
 * facilitator, or a dispute adjudicator handed a payout receipt can
 * check it against the platform's frozen record. Top-level public
 * route (/verify-receipt); ApiProvider's anonymous-401 redirect
 * skips this path explicitly. Logged-in users normally reach the
 * same form as a footer modal instead of this auth-chrome page.
 */
export const VerifyReceipt = () => {
  const params = new URLSearchParams(window.location.search);
  return (
    <AuthShell>
      <div className="form-wrapper">
        <div className="form-wrapper-header">
          <h2>Verify a receipt</h2>
          <CardThemeToggle />
        </div>
        <VerifyReceiptForm initialCode={params.get("code") || ""} />
      </div>
    </AuthShell>
  );
};

export default VerifyReceipt;
